import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_MDS_ASSESSMENT_FAILURE,
  GET_MDS_ASSESSMENT_REQUEST,
  GET_MDS_ASSESSMENT_SUCCESS,
  GET_MDS_ASSESSMENT_LOADING,
} = therapyPlanningAction;

function* getMDSAssessment(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_MDS_ASSESSMENT_LOADING });
    const response = yield call(therapyPlanningService.getMDSAassessment, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_MDS_ASSESSMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_MDS_ASSESSMENT_FAILURE, payload: error });
  }
}

function* getMDSAssessmentSaga() {
  yield takeEvery(GET_MDS_ASSESSMENT_REQUEST, getMDSAssessment);
}

export default getMDSAssessmentSaga;
